import Navbar from "../../components/navbar/index.jsx";
import ListaAno from "../../components/ListaAno/ListaAno.jsx";
import Imagem from "../../assets/Adobe.png"
import  './index.css';

function Documentos(){

   var NomeUsuario = localStorage.getItem("NomeUsuario");
    return  <div>
          <Navbar/>
            <div className="container-fluid titulo" >
                 <div className="invisivel">
                          <h6> '' </h6> 
                 </div>  
                 <h6> {NomeUsuario} </h6>  
                 <h7> Lista de documentos disponíveis </h7>      
                 <ListaAno tipo ='D' imagem={Imagem} />
            </div>
    </div>

}
export default Documentos;
